import { template } from "@ember/template-compiler";
import { LinkTo } from '@ember/routing';
export default template(`
	<ul class="filters">
		<li>
			<LinkTo @route="index" @activeClass="selected">
				All
			</LinkTo>
		</li>
		<li>
			<LinkTo @route="active" @activeClass="selected">
				Active
			</LinkTo>
		</li>
		<li>
			<LinkTo @route="completed" @activeClass="selected">
				Completed
			</LinkTo>
		</li>
	</ul>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
